import {
  makePaymentDashboardPaymentButtonElem,
  makePaymentDashboardUrlData,
  makePaymentDashboardLogUrlData,
  makePaymentProviderData,
  aptexxModalImplementation,
  unitsSelectElem,
  multipleLedgersContainer
} from './constants'
import { paymentDashboardLoadingHide, paymentDashboardLoadingShow } from '../loading'
import { paymentDashboardButtonEnable, paymentDashboardButtonDisable } from './button'
import { paymentDashboardBalance, paymentShowAttorneyBalance } from './balance'
import { paymentDashboardRecurringHide, paymentDashboardRecurringShow } from './recurring'
import paymentDashboardErrors from './errors'
import paymentModalOpen from '../modal/open'
import paymentModalErrors from '../modal/errors'
import paymentDataLoad, { isMultipleLedgers } from '../load'
import { paymentModalSuccess, paymentModalFailure } from '../modal/request'

export function paymentDashboardSuccess (data, _textStatus, _jqXHR) {
  let payment = data[0];
  const singleLedgerWithBalance = payment.accounts !== undefined && payment.accounts.filter(account => account.balance !== 0).length === 1;

  if (singleLedgerWithBalance) {
    payment = {...payment, ...payment.accounts.find(account => account.balance !== 0)};
  }

  paymentDashboardErrors(payment.accounting_errors, payment.payment_errors)
  paymentDashboardBalance(payment)

  if (window.unitsPaymentData && window.unitsPaymentData.length > 1) {
    renderUnitsSelectElem(window.unitsPaymentData)
  }

  if (isMultipleLedgers(payment)) {
    generateAccountTable(payment);
  } else {
    if (payment.allow_payments) {
      paymentDashboardButtonEnable()
      paymentDashboardRecurringShow()
    } else {
      paymentDashboardButtonDisable()
      paymentDashboardRecurringHide()
    }

    // This will be enabled if account balances is only one
    makePaymentDashboardPaymentButtonElem.on('click', function (evt) {
      // Aptexx with only one unit
      if (makePaymentProviderData === 'aptexx' && data.length === 1) {
        aptexxUpdateTempPaymentLogToPending(payment)
        if (aptexxModalImplementation === "true") {
          paymentModalOpen();
          paymentDataLoad(makePaymentDashboardUrlData, paymentModalSuccess, paymentModalFailure);
        } else {
          const makePaymentAptexxUrl = payment.payment_url;
          window.open(makePaymentAptexxUrl, '_blank');
        }
      // FSPay or Aptexx with more than one unit
      } else {
        paymentModalOpen()
        paymentDataLoad(makePaymentDashboardUrlData, paymentModalSuccess, paymentModalFailure)
      }
    })
  }

  paymentDashboardLoadingHide(payment)
}

export function paymentDashboardFailure (_jqXHR, _textStatus, errorThrown) {
  const hasMultipleLedgers = $('#balance_container').data('payment-url').includes('multiple_ledgers=true');
  const errorMessages = [errorThrown]

  paymentModalErrors(errorMessages)

  if (hasMultipleLedgers) {
    paymentDashboardErrors(errorMessages)
  }

  paymentDashboardLoadingHide()
}

function aptexxUpdateTempPaymentLogToPending (payment) {
  const logUrl = `${makePaymentDashboardLogUrlData}?units_user_uuid=${payment.units_user_uuid}`

  $.ajax({
    url: logUrl,
    type: 'PUT',
    headers: { 'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content') }
  })
}

function renderUnitsSelectElem (data) {
  const selectOptions = data.map(unit => ({ id: unit.id, text: `${unit.id} - ${unit.street_1}`}));
  unitsSelectElem.select2({ data: selectOptions });
  unitsSelectElem.val(window.paymentData[0].unit_id || selectOptions[0].id).trigger('change');

  unitsSelectElem.on('change', function() {
    multipleLedgersContainer.empty();
    const currentValue = $(this).val();

    paymentDashboardLoadingShow();
    const hasMultipleLedgersQueryParam = makePaymentDashboardUrlData.includes('multiple_ledgers=true');
    const url = hasMultipleLedgersQueryParam ? `${makePaymentDashboardUrlData}&unit_id=${currentValue}` : `${makePaymentDashboardUrlData}?unit_id=${currentValue}`

    paymentDataLoad(url, (response) => {
      const payment = response[0];
      paymentDashboardBalance(payment);

      if (isMultipleLedgers(payment)) {
        generateAccountTable(payment);
      } else {
        if (payment.allow_payments) {
          paymentDashboardButtonEnable()
          paymentDashboardRecurringShow()
        } else {
          paymentDashboardButtonDisable()
          paymentDashboardRecurringHide()
        }

        // This will be enabled if account balances is only one
        makePaymentDashboardPaymentButtonElem.on('click', function (evt) {
          // Aptexx with only one unit
          if (makePaymentProviderData === 'aptexx' && data.length === 1) {
            aptexxUpdateTempPaymentLogToPending(payment)
            if (aptexxModalImplementation === "true") {
              paymentModalOpen();
              paymentDataLoad(makePaymentDashboardUrlData, paymentModalSuccess, paymentModalFailure);
            } else {
              const makePaymentAptexxUrl = payment.payment_url;
              window.open(makePaymentAptexxUrl, '_blank');
            }
          // FSPay or Aptexx with more than one unit
          } else {
            paymentModalOpen()
            paymentDataLoad(makePaymentDashboardUrlData, paymentModalSuccess, paymentModalFailure)
          }
        })
      }

      paymentDashboardLoadingHide(payment);
      paymentModalSuccess(response);
    }, paymentDashboardFailure, $.noop, null, true)
  });
}

function generateAccountTable(payment) {
  const filteredAccounts = payment.accounts.filter(account => account.balance !== 0);
  const table = $('<table>').attr('id', 'ledgerTable');

  $.each(filteredAccounts, function (_index, row) {
    const tr = $('<tr>')
    tr.append(`<td>${row.account_name}</td>`)

    if (paymentShowAttorneyBalance(row)) {
      tr.append(`<td></td>`)
      tr.append(`
        <td>
          <button id='make_payment_button' class="btn-sm btn multi-pay-button" disabled="disabled">Pay</button>
        </td>
      `)
    } else {
      tr.append(`<td>${row.formatted_balance}</td>`)
      tr.append(`
        <td>
          <button id='make_payment_button' class="btn-sm btn-success multi-pay-button" data-account-number=${row.account_number} data-balance=${row.balance} data-payment-url=${row.payment_url}>Pay</button>
        </td>
      `)
    }

    table.append(tr);
  });
  multipleLedgersContainer.append(table);

  $('#ledgerTable button').not(':disabled').on('click', function (evt) {
    evt.preventDefault();
    const accountNumber = $(this).data('account-number');
    const selectedRowValue = `${payment.units_user_uuid}|${accountNumber}`;

    paymentModalOpen()
    paymentDataLoad(makePaymentDashboardUrlData, paymentModalSuccess, paymentModalFailure, null, selectedRowValue)
  })
}